import React from "react";
import { Card, Row, Col, Space, Flex, Typography } from "antd";
import { FileTextOutlined, FolderOpenOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;

interface FinanceTreeStatsProps {
  totalItems: number;
  mainCategories: number;
  filteredItems: number;
  searchValue: string;
}

const FinanceTreeStats: React.FC<FinanceTreeStatsProps> = ({
  totalItems,
  mainCategories,
  filteredItems,
  searchValue,
}) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[20, 20]}>
      <Col xs={24} sm={12} md={8}>
        <Card
          variant="borderless"
          className="stat-card"
          style={{
            borderRadius: "16px",
            boxShadow: "0 4px 16px rgba(24, 144, 255, 0.15)",
            background: "linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)",
            border: "2px solid #91d5ff",
          }}
          styles={{ body: { padding: "24px" } }}
        >
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            <Flex justify="space-between" align="center">
              <Text
                style={{
                  color: "#096dd9",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {t("label.total_items")}
              </Text>
              <FileTextOutlined style={{ fontSize: "24px", color: "#1890ff", opacity: 0.6 }} />
            </Flex>
            <Title
              level={2}
              style={{
                margin: "12px 0 0 0",
                color: "#0050b3",
                fontWeight: 700,
                fontSize: "36px",
              }}
            >
              {totalItems}
            </Title>
          </Space>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Card
          variant="borderless"
          className="stat-card"
          style={{
            borderRadius: "16px",
            boxShadow: "0 4px 16px rgba(82, 196, 26, 0.15)",
            background: "linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)",
            border: "2px solid #b7eb8f",
          }}
          styles={{ body: { padding: "24px" } }}
        >
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            <Flex justify="space-between" align="center">
              <Text
                style={{
                  color: "#389e0d",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {t("label.main_categories")}
              </Text>
              <FolderOpenOutlined style={{ fontSize: "24px", color: "#52c41a", opacity: 0.6 }} />
            </Flex>
            <Title
              level={2}
              style={{
                margin: "12px 0 0 0",
                color: "#237804",
                fontWeight: 700,
                fontSize: "36px",
              }}
            >
              {mainCategories}
            </Title>
          </Space>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Card
          variant="borderless"
          className="stat-card"
          style={{
            borderRadius: "16px",
            boxShadow: "0 4px 16px rgba(250, 173, 20, 0.15)",
            background: "linear-gradient(135deg, #fffbe6 0%, #fff1b8 100%)",
            border: "2px solid #ffe58f",
          }}
          styles={{ body: { padding: "24px" } }}
        >
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            <Flex justify="space-between" align="center">
              <Text
                style={{
                  color: "#d48806",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {t("label.filtered_items")}
              </Text>
              <SearchOutlined style={{ fontSize: "24px", color: "#faad14", opacity: 0.6 }} />
            </Flex>
            <Title
              level={2}
              style={{
                margin: "12px 0 0 0",
                color: "#ad6800",
                fontWeight: 700,
                fontSize: "36px",
              }}
            >
              {searchValue ? filteredItems : "-"}
            </Title>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default FinanceTreeStats;

